import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23b38594&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b38594')) {
      api.createRecord('23b38594', component.options)
    } else {
      api.reload('23b38594', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=23b38594&", function () {
      api.rerender('23b38594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/report/index.vue"
export default component.exports